export default "__VITE_ASSET__DEAVuIVX__"